type Selector = <T, U extends keyof T>(src: T, ...fields: U[]) => Pick<T, U>;

/**
 * Utility function that creates an object containing a subset of the fields of a given
 * source object. Useful to create Zustand selectors.
 *
 * @param src The source object
 * @param fields Fields to pick from the source object
 * @returns A new object containing only the selected fields
 */
export const select: Selector = (src, ...fields) =>
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  fields.reduce((dst, field) => ({ ...dst, [field]: src[field] }), {} as any);
